const currentPasswordInput = document.querySelector('.current-password-input');
const newPasswordInput = document.querySelector('.new-password-input');
const confirmPasswordInput = document.querySelector('.confirm-password-input');

const showPasswordInputWrapper = (wrapper) => {
  const input = wrapper.querySelector('input');
  const showPasswordIcon = wrapper.querySelector('.show-password-icon');
  const hidePasswordIcon = wrapper.querySelector('.hide-password-icon');
  input.type = input.type === 'password' ? 'text' : 'password';
  showPasswordIcon.style.display = input.type === 'password' ? 'block' : 'none';
  hidePasswordIcon.style.display = input.type === 'password' ? 'none' : 'block';
};
if (currentPasswordInput) {
  currentPasswordInput.querySelector('button').addEventListener('click', () => {
    showPasswordInputWrapper(currentPasswordInput);
  });
}

if (newPasswordInput) {
  newPasswordInput.querySelector('button').addEventListener('click', () => {
    showPasswordInputWrapper(newPasswordInput);
  });
}

if (confirmPasswordInput) {
  confirmPasswordInput.querySelector('button').addEventListener('click', () => {
    showPasswordInputWrapper(confirmPasswordInput);
  });
}

const loginPasswordInput = document.querySelector('.login-password-input');
if (loginPasswordInput) {
  loginPasswordInput.querySelector('button').addEventListener('click', () => {
    showPasswordInputWrapper(loginPasswordInput);
  });
}
